import React from "react";
import { Link } from "react-router-dom";

/**
 * Styled hyperlink for entity references (employee names, module chips,
 * project names, etc.). Renders a keyboard-accessible <a>-shaped element
 * with the ASL navy accent, subtle underline on hover.
 *
 * Props:
 *   to:       absolute route (module-scoped) — required
 *   onNav:    optional callback fired before navigation (e.g. to close a
 *             parent modal so the browser back stack returns cleanly)
 *   variant:  "chip" for compact pill styling, otherwise inline text
 *   testid:   data-testid for QA
 *   children: display text
 */
export default function EntityLink({
    to,
    onNav,
    variant,
    testid,
    className = "",
    children,
    title,
}) {
    if (!to) {
        return <span className={className}>{children}</span>;
    }
    if (variant === "chip") {
        return (
            <Link
                to={to}
                onClick={() => { onNav && onNav(); }}
                title={title}
                data-testid={testid}
                className={`inline-flex items-center text-[10px] px-2 py-0.5 rounded-full asl-navy-text hover:asl-crimson-text hover:underline transition-colors ${className}`}
                style={{ background: "var(--asl-navy-50)" }}
            >
                {children}
            </Link>
        );
    }
    return (
        <Link
            to={to}
            onClick={() => { onNav && onNav(); }}
            title={title}
            data-testid={testid}
            className={`asl-navy-text hover:asl-crimson-text hover:underline underline-offset-2 transition-colors cursor-pointer ${className}`}
        >
            {children}
        </Link>
    );
}
